function csrfToken() {
  const tag = document.querySelector("meta[name='csrf-token']");
  return tag ? tag.content : "";
}

function appendMessage(container, text, type, links, disclaimer, personalization) {
  const message = document.createElement("div");
  message.className = `petter-ai-chat__message petter-ai-chat__message--${type}`;
  message.textContent = text;

  if (Array.isArray(links) && links.length > 0) {
    const list = document.createElement("div");
    list.className = "petter-ai-chat__links";
    links.forEach((link) => {
      const anchor = document.createElement("a");
      anchor.href = link.url;
      anchor.textContent = link.label;
      if (/^https?:\/\//.test(link.url)) {
        anchor.target = "_blank";
        anchor.rel = "noopener noreferrer";
      }
      list.appendChild(anchor);
    });
    message.appendChild(list);
  }

  if (disclaimer) {
    const note = document.createElement("small");
    note.textContent = disclaimer;
    message.appendChild(note);
  }

  if (personalization && personalization.enabled) {
    const context = document.createElement("small");
    const labels = Array.isArray(personalization.data_labels) ? personalization.data_labels : [];
    if (labels.length > 0) {
      context.textContent = `参照: ${labels.join("・")}`;
    } else if (personalization.selection_required) {
      context.textContent = "参照: 相談する子を選んでください";
    } else {
      context.textContent = "参照: 登録済み情報なし";
    }
    context.className = "petter-ai-chat__context";
    message.appendChild(context);
  }

  container.appendChild(message);
  container.scrollTop = container.scrollHeight;
}

function setupPetterAiChat() {
  const root = document.querySelector("[data-petter-ai-chat]");
  if (!root || root.dataset.initialized === "true") return;
  root.dataset.initialized = "true";

  const panel = root.querySelector("[data-ai-chat-panel]");
  const messages = root.querySelector("[data-ai-chat-messages]");
  const form = root.querySelector("[data-ai-chat-form]");
  const input = root.querySelector("[data-ai-chat-input]");
  const endpoint = root.dataset.endpoint;
  const personalizationEndpoint = root.dataset.personalizationEndpoint;
  const personalizationToggle = root.querySelector("[data-ai-personalization-toggle]");
  const personalizationStatus = root.querySelector("[data-ai-personalization-status]");
  const petSelect = root.querySelector("[data-ai-pet-select]");
  const conversation = [];
  const isSmallScreen = () => window.matchMedia("(max-width: 575.98px)").matches;

  const updateViewportHeight = () => {
    const height = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    document.documentElement.style.setProperty("--petter-ai-vh", `${Math.max(360, Math.round(height))}px`);
  };

  const rememberMessage = (role, content) => {
    conversation.push({ role, content });
    if (conversation.length > 8) conversation.shift();
  };

  document.querySelectorAll("[data-ai-chat-toggle]").forEach((button) => {
    if (button.dataset.aiToggleBound === "true") return;
    button.dataset.aiToggleBound = "true";
    button.addEventListener("click", () => {
      root.classList.toggle("is-open");
      updateViewportHeight();
      if (root.classList.contains("is-open") && !isSmallScreen()) input.focus();
    });
  });

  root.querySelector("[data-ai-chat-close]").addEventListener("click", () => {
    root.classList.remove("is-open");
  });

  root.querySelectorAll("[data-ai-chat-sample]").forEach((button) => {
    button.addEventListener("click", () => {
      input.value = button.dataset.aiChatSample;
      form.requestSubmit();
    });
  });

  if (personalizationToggle) {
    personalizationToggle.addEventListener("change", () => {
      const enabled = personalizationToggle.checked;
      personalizationToggle.disabled = true;
      if (personalizationStatus) personalizationStatus.textContent = "更新中";

      fetch(personalizationEndpoint, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken(),
          "Accept": "application/json"
        },
        body: JSON.stringify({ enabled })
      })
        .then((response) => {
          if (!response.ok) throw new Error("personalization update failed");
          return response.json();
        })
        .then((data) => {
          root.dataset.personalizationEnabled = data.enabled ? "true" : "false";
          if (petSelect) petSelect.disabled = !data.enabled;
          if (personalizationStatus) personalizationStatus.textContent = data.enabled ? "利用中" : "利用しない";
        })
        .catch(() => {
          personalizationToggle.checked = !enabled;
          if (petSelect) petSelect.disabled = enabled;
          if (personalizationStatus) personalizationStatus.textContent = "更新できませんでした";
        })
        .finally(() => {
          personalizationToggle.disabled = false;
        });
    });
  }

  form.addEventListener("submit", (event) => {
    event.preventDefault();
    const value = input.value.trim();
    if (!value) return;

    appendMessage(messages, value, "user");
    rememberMessage("user", value);
    input.value = "";
    const loading = "調べています...";
    appendMessage(messages, loading, "bot");
    const loadingNode = messages.lastElementChild;

    fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken(),
        "Accept": "application/json"
      },
      body: JSON.stringify({
        message: value,
        history: conversation.slice(0, -1),
        pet_id: petSelect && !petSelect.disabled ? petSelect.value : null
      })
    })
      .then((response) => response.json())
      .then((data) => {
        loadingNode.remove();
        appendMessage(messages, data.reply, "bot", data.links, data.disclaimer, data.personalization);
        rememberMessage("bot", data.reply);
      })
      .catch(() => {
        loadingNode.remove();
        appendMessage(messages, "すみません、うまく返答できませんでした。少し時間をおいてもう一度お試しください。", "bot");
      });
  });

  panel.addEventListener("click", (event) => {
    event.stopPropagation();
  });

  updateViewportHeight();
  window.addEventListener("resize", updateViewportHeight);
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", updateViewportHeight);
    window.visualViewport.addEventListener("scroll", updateViewportHeight);
  }
}

document.addEventListener("turbolinks:load", setupPetterAiChat);
document.addEventListener("DOMContentLoaded", setupPetterAiChat);
